




import { Component, Vue } from 'vue-property-decorator';

@Component({
  components: {
    PagePresetDashboard: () => import('@/layouts/presets/dashboard.vue'),
  },
})
export default class PageCustomers extends Vue {}
